export const DEFAULT_MODULES_PER_PAGE = 5
export const DEFAULT_SESSIONS_PER_PAGE = 10

export const BRANCHE_CAP = "25"
export const CAP_COMPETENCE_URL = "/capcompetence"

export const STAGE_TYPE_INTER = '1'
export const STAGE_TYPE_INTRA = '2'

export const SESSION_TYPE_INTER = '1'
export const SESSION_TYPE_INTRA = '2'

export const SESSION_MODALITE_PRESENTIEL = '1'
export const SESSION_MODALITE_MIXTE = '2'
export const SESSION_MODALITE_EN_LIGNE = '3'
export const SESSION_MODALITE_CLASSE_VIRTUELLE = '4'

export const MODALITES_LABELS = new Map([
    [ '1', "Présentiel" ],
    [ '2', "Mixte" ],
    [ '3', "En ligne" ],
    [ '4', "Classe virtuelle" ],
])

export const MODALITES_TOOLTIPS = new Map([
    [ '1', "Formation synchrone se déroulant avec la présence physique du (des) formateur(s) et du (des) apprenant(s) réunis dans un même lieu de formation." ],
    [ '2', "Formation combinant des séquences en présentiel et des séquences à distance synchrones ou asynchrones." ],
    [ '3', "Formation à distance, asynchrone, s’appuyant sur une plateforme d’apprentissage, pouvant être complétée par d’autres modalités de formation à distance (visio-conférence…)." ],
    [ '4', "Formation à distance, synchrone, s’appuyant sur un dispositif de visio-conférence. La classe virtuelle recrée à distance les conditions d’une formation en salle traditionnelle." ],
])

export const TYPES_TOOLTIPS = new Map([
    [ '1', "La formation en Inter est dispensée pour un groupe de salariés d’entreprises différentes." ],
    [ '2', "La formation en Intra est dispensée pour un groupe de salariés d’une seule et même entreprise." ],
])

export const OPTIONS_TOOLTIPS = new Map([
    [
        'cofinancement',
        'Bénéficie d’un financement d’un partenaire d’Atlas.'
    ],
    [
        'dda-compatible',
        `Respecte les exigences de la Directive Distribution d'Assurance&nbsp;(DDA).`
    ],
    [
        'formation-certifiante',
        'Les compétences professionnelles visées par la formation sont validées via un test permettant d’obtenir une certification officielle.'
    ],
    [
        'libre-acces',
        'Accessible sans impact sur le budget de l’entreprise.'
    ],
    [
        'session-garantie',
        'Ces sessions ne peuvent être ni annulées ni reportées par l’organisme de formation.'
    ],
])
